/**
 * En este archivo se en lista las constantes que seran utilizadas en el Sistema
 */


const product_status = {
  0: 'ELIMINADO',     // 0
  1: 'ÓPTIMO',                      // 1
  2: 'BAJO',                       // 2
  3: 'MÍNIMO',                 // 3
  4: 'RESURTIR',          // 4
  5: 'AGOTADO'          // 5
};

const status_colors = {
  0: 'text-bg-danger',     // Eliminado / Descontinuado
  1: 'text-bg-primary',    // Óptimo
  2: 'text-bg-info',    // Bajo
  3: 'text-bg-secondary',  // Mínimo
  4: 'text-bg-warning',       // Resurtir
  5: 'text-bg-dark'        // Agotado
};


const requests_status = {
  1: 'SOLICITADO',     // 0
  2: 'REVISADO',                      // 1
  3: 'APROBADO',                       // 2
  4: 'POR RECIBIR',          // 4
  5: 'PARCIAL',          // 5
  6: 'COMPLETO',         // 5
  7: 'CANCELADO',        // 5
};


const status_requests_colors = {

  1: 'text-bg-info',    // solicitado
  2: 'text-bg-dark',    // revisado
  3: 'text-bg-primary',  // aprovado
  4: 'text-bg-primary',  // aprovado
  5: 'text-bg-warning',
  6: 'text-bg-success',        // completo
  7: 'text-bg-danger',     // Eliminado / Descontinuado
};



const status_slices = {
  WAITING: 'waiting',
  PROCESSING: 'processing_request',
  LOADED: 'loaded',
  NOT_LOADED: 'not_loaded',
  ERROR: 'error',
  SUCCESS: 'success'
};


export { status_slices, product_status, status_colors, requests_status, status_requests_colors };
